// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| DEPRECATED
| Migrate to CSS classes defined in /src/main/webapp/public/styles/common/ez-dialogs.css
| CSS variables defined in: /src/main/webapp/public/styles/common/ez-body.css
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
/* DEPRECATED */
.ezDialogs-content-container {
  display: grid;
  padding: 8px;
  background-color: var(--ezClockerWhite);
  color: var(--ezClockerBlack);
  font-family: var(--ezFontFamily);
  grid-template-rows: auto;
  grid-template-columns: min auto;
  align-content: start;
  justify-content: stretch;
}

/* DEPRECATED */
.ezDialogs-left-info-image-container {
  padding: 4px;
  width: 24px;
  min-height: 24px;
  background-color: transparent;
  text-align: center;
  background-image: url("/public/images/icons/info.svg");
  background-position: center;
  background-repeat: none;
  background-size: 24px;
}

/* DEPRECATED */
.ezDialogs-right-message-container {
  color: var(--ezClockerBlack);
  font-family: var(--ezFontFamily);
  text-align: left;
}

/* DEPRECATED */
div.ezClockerDialog {
  display: none;
}

/* DEPRECATED */
img.ezClockerDialogImage {
  width: 48px;
  min-height: 48px;
}

/* DEPRECATED */
table.ezClockerDialogContent {
  width: 100%;
  border-style: none;
}

/* DEPRECATED */
tr.ezDialog-table-row-no-border {
  border-style: none;
}

/* DEPRECATED */
td.ezClockerDialogImageCell {
  padding: 8px;
  background-color: transparent;
  text-align: center;
  vertical-align: top;
  border-style: none;
}

/* DEPRECATED */
td.ezClockerDialogMessageCell {
  vertical-align: top;
  text-align: left;
  font: var(--ezFontFamily);
  font-size: var(--ezFontSize);
  font-style: var(--ezFontStyle);
  font-weight: var(--ezFontWeight);
  border-style: none;
}

/* DEPRECATED */
div.genericDialog {
  padding: 8px;
}

/* DEPRECATED */
.ezDialogTextInputContainerHighlight {
  box-shadow: 0 0 15px 1px var(--ezClockerYellow);
}`, "",{"version":3,"sources":["webpack://./public/styles/common/ezclocker-dialog.css"],"names":[],"mappings":"AAAA;;;;iEAAA;AAMA,eAAA;AAAgB;EACZ,aAAA;EACA,YAAA;EACA,uCAAA;EACA,4BAAA;EACA,gCAAA;EACA,wBAAA;EACA,+BAAA;EACA,oBAAA;EACA,wBAAA;AACJ;;AAEA,eAAA;AAAgB;EACZ,YAAA;EACA,WAAA;EACA,gBAAA;EACA,6BAAA;EACA,kBAAA;EACA,sDAAA;EACA,2BAAA;EACA,uBAAA;EACA,qBAAA;AAEJ;;AACA,eAAA;AAAgB;EACZ,4BAAA;EACA,gCAAA;EACA,gBAAA;AAGJ;;AAAA,eAAA;AAAgB;EACZ,aAAA;AAIJ;;AADA,eAAA;AAAgB;EACZ,WAAA;EACA,gBAAA;AAKJ;;AAFA,eAAA;AAAgB;EACZ,WAAA;EACA,kBAAA;AAMJ;;AAHA,eAAA;AAAgB;EACZ,kBAAA;AAOJ;;AAJA,eAAA;AAAgB;EACZ,YAAA;EACA,6BAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AAQJ;;AALA,eAAA;AAAgB;EACZ,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,4BAAA;EACA,8BAAA;EACA,gCAAA;EACA,kBAAA;AASJ;;AANA,eAAA;AAAgB;EACZ,YAAA;AAUJ;;AAPA,eAAA;AAAgB;EACZ,+CAAA;AAWJ","sourcesContent":["/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| DEPRECATED\r\n| Migrate to CSS classes defined in /src/main/webapp/public/styles/common/ez-dialogs.css\r\n| CSS variables defined in: /src/main/webapp/public/styles/common/ez-body.css\r\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\r\n\r\n/* DEPRECATED */.ezDialogs-content-container {\r\n    display: grid;\r\n    padding: 8px;\r\n    background-color: var(--ezClockerWhite);\r\n    color: var(--ezClockerBlack);\r\n    font-family: var(--ezFontFamily);\r\n    grid-template-rows: auto;\r\n    grid-template-columns: min auto;\r\n    align-content: start;\r\n    justify-content: stretch;\r\n}\r\n\r\n/* DEPRECATED */.ezDialogs-left-info-image-container {\r\n    padding: 4px;\r\n    width: 24px;\r\n    min-height: 24px;\r\n    background-color: transparent;\r\n    text-align: center;\r\n    background-image: url(\"/public/images/icons/info.svg\");\r\n    background-position: center;\r\n    background-repeat: none;\r\n    background-size: 24px;\r\n}\r\n\r\n/* DEPRECATED */.ezDialogs-right-message-container {\r\n    color: var(--ezClockerBlack);\r\n    font-family: var(--ezFontFamily);\r\n    text-align: left;\r\n}\r\n\r\n/* DEPRECATED */div.ezClockerDialog {\r\n    display: none;\r\n}\r\n\r\n/* DEPRECATED */img.ezClockerDialogImage {\r\n    width: 48px;\r\n    min-height: 48px;\r\n}\r\n\r\n/* DEPRECATED */table.ezClockerDialogContent {\r\n    width: 100%;\r\n    border-style: none;\r\n}\r\n\r\n/* DEPRECATED */tr.ezDialog-table-row-no-border {\r\n    border-style: none;\r\n}\r\n\r\n/* DEPRECATED */td.ezClockerDialogImageCell {\r\n    padding: 8px;\r\n    background-color: transparent;\r\n    text-align: center;\r\n    vertical-align: top;\r\n    border-style: none;\r\n}\r\n\r\n/* DEPRECATED */td.ezClockerDialogMessageCell {\r\n    vertical-align: top;\r\n    text-align: left;\r\n    font: var(--ezFontFamily);\r\n    font-size: var(--ezFontSize);\r\n    font-style: var(--ezFontStyle);\r\n    font-weight: var(--ezFontWeight);\r\n    border-style: none;\r\n}\r\n\r\n/* DEPRECATED */div.genericDialog {\r\n    padding: 8px;\r\n}\r\n\r\n/* DEPRECATED */.ezDialogTextInputContainerHighlight {\r\n    box-shadow: 0 0 15px 1px var(--ezClockerYellow);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
